import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppPropertyBasicModel, HxStoreService, StoreFullModel } from 'hx-services';
import { ActivatedRoute, Data, RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { JsonPipe, NgFor, NgIf } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-store-properties-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, TranslocoDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, NgIf, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, JsonPipe, TranslocoPipe]
})
export class StorePropertyListComponent implements OnInit, OnDestroy {
  store!: StoreFullModel;
  isLoading = {
    properties: false
  };
  properties: AppPropertyBasicModel[] = [];


  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private storeService: HxStoreService,
    private tr: TranslocoService,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.store = routeData['store'] as StoreFullModel;
    this.loadProperties();
  }

  remove(id: number): void {
    this.storeService.removeProperty(this.store.id, id).subscribe(() => this.loadProperties());
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  private loadProperties() {
    this.isLoading.properties = true;
    this.storeService.getPropertiesById(this.store.id)
      .subscribe(properties => this.properties = properties,
        () => {
        }, () => this.isLoading.properties = false);
  }
}
